import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import { ColorClassSuffix } from 'features/shared/enums/colorClassSuffix';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  route: string; 
  colorSuffix?: ColorClassSuffix;
  isOutline?: boolean;
  className?: string;
}

const ResultDialogButton = ({ title, route, colorSuffix = "primary", isOutline, className }: Props) => {
  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // render
  return (
    <Link
        className={`btn btn${isOutline ? "-outline" : ""}-${colorSuffix}${className ? ` ${className}` : ""}`}
        to={route}
        onClick={() => dialogService.closeDialog()}
      >
        {title}
      </Link>
  )
}

export default ResultDialogButton;
